import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section1: FC<{ onClickButton: () => void }> = ({ onClickButton }) => {
  return (
    <L_Section1>
      <L_Section1Container>
        <L_Section1_T>
          <strong>
            기업 성장에 날개를 달아주는 임직원 교육,
            <br />
            클래스유에서 시작하세요.
          </strong>
        </L_Section1_T>

        <L_Section1_B>
          직무 교육부터 자기 계발을 위한 교육, 법정교육까지
          <br />
          임직원의 성장이 기업의 성장으로 연결됩니다.
          <br />
          <br />
          <br />
        </L_Section1_B>
        <L_Section1_B_Btn onClick={onClickButton}>기업교육 문의하기</L_Section1_B_Btn>
      </L_Section1Container>
      <L_Section1Backdrop />
      <picture>
        <img src="biz-banner.png" alt="" loading="lazy" />
      </picture>
    </L_Section1>
  );
};

const L_Section1_T = styled.p`
  padding-bottom: 3.6rem;
  & > strong {
    font-size: 2.4rem;
  }
`;
const L_Section1_B = styled.p`
  font-size: 1.6rem;
`;
const L_Section1_B_Btn = styled.button`
  color: white;
  background-color: ${palette.Primary.Active};
  padding: 1.6rem 6rem;
  white-space: nowrap;
  border-radius: 0.4rem;
  font-size: 1.6rem;
  font-weight: bold;
  margin: 0 auto;
`;

const L_Section1Container = styled.div`
  position: relative;
  z-index: 3;
  width: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  color: #000;
  padding-top: 12rem;
  padding-bottom: 12rem;
  * {
    color: #fff;
  }
`;
const L_Section1Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.8);
`;

const L_Section1 = styled.section`
  text-align: center;
  position: relative;
  & > picture > img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  & > picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    overflow: hidden;
  }
`;

export default Section1;
